import { Divider } from '@tunasong/ui-lib'
import { type Chord } from '@tunasong/music-lib'
import { ChordChooser, ScaleSelect } from '@tunasong/music-ui'
import type { Scale } from '@tunasong/schemas'
import { useState, type FC } from 'react'

export interface ChordsProps {
  onChange?(chord: Chord): void
}

export const GuitarChordsPage: FC<ChordsProps> = props => {
  const { onChange } = props

  const [selected, setSelected] = useState<Chord>()
  const handleChooseChord = (chord: Chord) => {
    setSelected(chord)
    onChange?.(chord)
  }

  const [scale, setScale] = useState<Scale | null>({ root: 'C', type: 'major' })

  return (
    <>
      <ScaleSelect variant="common" value={scale} onChange={setScale} />
      <Divider style={{ marginTop: 8, marginBottom: 8 }} />
      <ChordChooser chord={selected} onChange={handleChooseChord} scale={scale} />
    </>
  )
}
